// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"5962f946","453":"3f5fd21a"}[chunkId] + ".chunk.js";
};